<div class="my-2 space-y-2 font-semibold">
  <div class="mb-1 rounded border border-[#d3d3d3] dark:border-[#1b2e4b]">
    <button type="button" class="flex w-full items-center p-4 text-white-dark dark:bg-[#1b2e4b]" [ngClass]="{ '!text-primary': accordion === orderNumber }" (click)="setVisibleAccordion()">
      {{ title | translate }}
      <div class="ltr:ml-auto rtl:mr-auto" [ngClass]="{ 'rotate-180': accordion === 0 }">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4">
          <path d="M19 9L12 15L5 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </button>
    <div [@slideDownUp]="accordion !== orderNumber" class="accordion-content">
      <div class="space-y-2 border-t border-[#d3d3d3] p-4 text-[13px] text-white-dark dark:border-[#1b2e4b]">
        <div class="space-y-1">
          <div
            class="flex h-10 w-full items-center justify-between rounded-md p-2 font-medium hover:bg-white-dark/10 hover:text-primary dark:hover:bg-[#181F32] dark:hover:text-primary"
            *ngFor="let item of options"
          >
            <div class="flex h-full w-full items-center py-2">
              <div class="flex w-full items-center">
                {{ item.title }}
              </div>
              <div class="flex items-center gap-1">
                <div>
                  <a type="button" [ngxTippy]="'edit' | translate" class="btn btn-dark h-10 w-10 rounded-full p-0" (click)="openModalForEditing(item.id)">
                    <icon-pencil-paper />
                  </a>
                </div>
                <div *appHasRole="[userRole.SuperAdmin]">
                  <a type="button" [ngxTippy]="'category_delete' | translate" class="btn btn-dark h-10 w-10 cursor-pointer rounded-full p-0" (click)="deletePicklistOption(item.id)">
                    <icon-trash-lines />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-center">
            <button type="button" class="btn btn-primary" (click)="openModal()">
              <icon-plus class="rotate-90 opacity-70 hover:opacity-100" />
              {{ "add_new_picklist_option" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modalTemplate>
  <div class="flex flex-col p-4">
    <div class="!pb-5 text-xl">{{ modalTitle }}</div>
    <form [formGroup]="form" class="text-sm">
      <div class="mt-3 grid grid-cols-1 gap-5 md:grid-cols-1">
        <div [ngClass]="form.controls['title'].touched ? (form.controls['title'].errors ? 'has-error' : 'has-success') : ''">
          <label for="title">{{ "settings.name" | translate }}</label>
          <input id="title" type="text" placeholder="{{ 'settings.cash' | translate }}" class="form-input" formControlName="title" #nameInput />
          <ng-container *ngIf="form.controls['title'].touched && form.controls['title'].errors">
            <p class="mt-1 text-danger">
              <small>{{ "settings.please_provide_title" | translate }}</small>
            </p>
          </ng-container>
        </div>
      </div>

      <div class="mt-3 grid grid-cols-1 gap-5 md:grid-cols-1">
        <div [ngClass]="form.controls['description'].touched ? (form.controls['description'].errors ? 'has-error' : 'has-success') : ''">
          <label for="description">{{ "settings.description" | translate }}</label>
          <input id="description" type="text" placeholder="{{ 'settings.description' | translate }}" class="form-input" formControlName="description" />
          <ng-container *ngIf="form.controls['description'].touched && form.controls['description'].errors">
            <p class="mt-1 text-danger">
              <small>{{ "settings.please_provide_description" | translate }}</small>
            </p>
          </ng-container>
        </div>
      </div>

      <div class="mt-3 grid grid-cols-1 gap-5 md:grid-cols-1">
        <div [ngClass]="form.controls['value'].touched ? (form.controls['value'].errors ? 'has-error' : 'has-success') : ''">
          <label for="value">{{ "settings.value" | translate }}</label>
          <input id="value" type="text" placeholder="{{ 'settings.value' | translate }}" class="form-input" formControlName="value" />
          <ng-container *ngIf="form.controls['value'].touched && form.controls['value'].errors">
            <p class="mt-1 text-danger">
              <small>{{ "settings.please_provide_value" | translate }}</small>
            </p>
          </ng-container>
        </div>
      </div>

      <div class="mt-8 flex items-center justify-end">
        <button type="submit" class="btn btn-primary" [disabled]="isLoading" (click)="addItem()">{{ modalButton }}</button>
      </div>
    </form>
  </div>
</ng-template>
